import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
// import IconButton from '@mui/material/IconButton';
import Button from 'components/Common/Button'
// import CloseIcon from '@mui/icons-material/Close';
import DialogActions from '@mui/material/DialogActions';

const sx = {
    main: {
        p: {
            color: "#66668F",
            fontSize: "16px",
            lineHeight: "24px",
            padding: "0 8%",
            fontWeight: 400
        }
    },

    dialog: {
        marginTop: "60px", 
        "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "710px", 
              height: "90%",
            }
        },
        '.MuiDialog-paper':{
           borderRadius: "20px"
      }
    },

    action: {
        justifyContent: "center",
        margin: "10px 0 25px 0"
    },

}

export default function NavDisclosure({ open, onClose }) {
    return (
        <div>
            <Dialog open={open} sx={sx.dialog} PaperProps={{ sx: { maxHeight: "700px" } }} >
                <DialogTitle textAlign={"center"} sx={{margin: "15px 0"}} > Advertiser Disclosure </DialogTitle>
                    
                <DialogContent sx={sx.main}>

                    <p>
                        The credit card, financing and service products that appear on this site are from credit card, 
                        financing and service companies from which this site receives compensation. This compensation may impact 
                        how and where products appear on this site (including, for example, the order in which they appear). 
                        This site does not include all credit card, financing and service products or all available credit 
                        card, financing and service products. All images and trademarks are the property of their 
                        respective owners. Editorial and review content is the property of Nav, and has not been approved, 
                        provided, or reviewed by the company providing the credit card, financing, or service.
                    </p>
                    <p>
                        For complete information, see the terms and conditions on the credit card, financing and service issuer’s
                        website. While Nav always strives to present the most accurate information, we show a summary to help 
                        you choose a product, not the full legal terms. You should understand the full terms of products as stated 
                        by the issuer itself.
                    </p>
                    <p>
                        Nav uses the VantageScore 3.0 credit score to determine which credit offers are recommended which may differ 
                        from the credit score used by lenders and service providers. However, credit score alone does not guarantee 
                        or imply approval for any credit card, financing, or service offer.
                    </p>

                </DialogContent>
                <DialogActions sx={sx.action}>
                    <Button sx={{width: "200px", height: "50px"}} onClick={onClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
